import { render } from "./HomeView.vue?vue&type=template&id=c543fe70&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=c543fe70&scoped=true&lang=css"

import exportComponent from "D:\\Clouds\\Programacion\\Vue\\words-search\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c543fe70"]])

export default __exports__